export const SHOW_TYPES = "show/";

export const GET_SHOWS_LIST = SHOW_TYPES + "getShowList";